import { Link } from "react-router-dom";
import { useTheme } from "@/hooks/use-theme";
import logoLight from "@/assets/logo-light.png";
import logoDark from "@/assets/logo-dark.png";

export function Footer() {
  const { resolvedTheme } = useTheme();

  return (
    <footer className="bg-card border-t mt-16">
      {/* Main content */}
      <div className="container mx-auto px-4 py-12">
        <div className="grid grid-cols-1 md:grid-cols-4 gap-10">
          {/* Logo & Description */}
          <div className="md:col-span-1">
            <Link to="/" className="inline-block mb-4">
              <img
                src={resolvedTheme === "dark" ? logoDark : logoLight}
                alt="Text.onl"
                className="h-8"
                loading="lazy"
              />
            </Link>
            <p className="text-muted-foreground text-sm leading-relaxed">
              Transform your text into beautiful Unicode styles for social media, gaming, and creative projects.
            </p>
          </div>

          {/* Tools */}
          <div>
            <h4 className="text-sm font-semibold text-foreground mb-4">Explore</h4>
            <ul className="space-y-2.5 text-sm">
              <li>
                <Link to="/tools" className="text-muted-foreground hover:text-primary transition-colors">
                  All Tools
                </Link>
              </li>
              <li>
                <Link to="/platforms" className="text-muted-foreground hover:text-primary transition-colors">
                  Platforms
                </Link>
              </li>
              <li>
                <Link to="/styles" className="text-muted-foreground hover:text-primary transition-colors">
                  All Styles
                </Link>
              </li>
              <li>
                <Link to="/custom-style" className="text-muted-foreground hover:text-primary transition-colors">
                  Custom Style Builder
                </Link>
              </li>
            </ul>
          </div>

          {/* Utilities */}
          <div>
            <h4 className="text-sm font-semibold text-foreground mb-4">Popular Tools</h4>
            <ul className="space-y-2.5 text-sm">
              <li>
                <Link
                  to="/tools/batch-transform"
                  className="text-muted-foreground hover:text-primary transition-colors"
                >
                  Batch Transform
                </Link>
              </li>
              <li>
                <Link to="/tools/unicode-lookup" className="text-muted-foreground hover:text-primary transition-colors">
                  Unicode Lookup
                </Link>
              </li>
              <li>
                <Link to="/tools/qr-code" className="text-muted-foreground hover:text-primary transition-colors">
                  QR Code Generator
                </Link>
              </li>
              <li>
                <Link to="/tools/social-preview" className="text-muted-foreground hover:text-primary transition-colors">
                  Social Preview
                </Link>
              </li>
              <li>
                <Link to="/tools/embed" className="text-muted-foreground hover:text-primary transition-colors">
                  Embed Widget
                </Link>
              </li>
            </ul>
          </div>

          <div>
            <h4 className="text-sm font-semibold text-foreground mb-4">Company</h4>
            <ul className="space-y-2.5 text-sm">
              <li>
                <Link to="/about" className="text-muted-foreground hover:text-primary transition-colors">
                  About Us
                </Link>
              </li>
              <li>
                <Link to="/contact" className="text-muted-foreground hover:text-primary transition-colors">
                  Contact Us
                </Link>
              </li>
              <li>
                <Link to="/privacy" className="text-muted-foreground hover:text-primary transition-colors">
                  Privacy Policy
                </Link>
              </li>
              <li>
                <Link to="/terms" className="text-muted-foreground hover:text-primary transition-colors">
                  Terms of Service
                </Link>
              </li>
              <li>
                <Link to="/install" className="text-muted-foreground hover:text-primary transition-colors">
                  Install App
                </Link>
              </li>
            </ul>
          </div>
        </div>
      </div>

      {/* Copyright */}
      <div className="border-t">
        <div className="container mx-auto px-4 py-6">
          <p className="text-center text-sm text-muted-foreground">
            © {new Date().getFullYear()} Text.onl — All rights reserved.
          </p>
        </div>
      </div>
    </footer>
  );
}
